import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2'

// Connects to data-controller="alert"
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    frame: String,
    confirmButtonText: String
  }
  connect() {

  }
  showModal() {
    Swal.fire({
      title: `<strong>${this.titleValue}</strong>`,
      html: `<turbo-frame id="${this.frame_tagValue}"> </turbo-frame>`,
    });
  }
}
